"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Hashtable_1 = require("../../Collections/HashMap/Hashtable");
var Exception_1 = require("../../Exceptions/Exception");
var StringUtils_1 = require("../../Utils/StringUtils");
var TextUtils_1 = require("../../Utils/TextUtils");
var Utils_1 = require("../../Utils/Utils");
var XmlAttributes_1 = require("./XmlAttributes");
var XmlNodeList_1 = require("./XmlNodeList");
var XmlNode = /** @class */ (function () {
    //protected m_doc:IXmlDocument;
    function XmlNode(parentNode, nodeName, attrs, defaultAttr, defaultAttrValue, events) {
        this.serialVersionUID = 5009966220209540301;
        //this.m_doc = doc;
        this.m_children = new Array();
        this.m_childrenNodes = new Hashtable_1.default();
        this.m_strName = nodeName;
        this.m_parent = parentNode;
        this.m_attrs = attrs || new XmlAttributes_1.default();
        if (parentNode != null) {
            parentNode.addChild(this, nodeName, defaultAttr, defaultAttrValue);
        }
        this.lstEvents = events;
    }
    /**
     * A13081301: Funcionalidad para manejar XML a nivel de script y modificar estructuras en runtime.
     * Construye un nodo XML a partir de otro similar. Copia los hijos, los atributos y el texto.
     *
     * @param Source
     * @param ParentNode
     */
    // public XmlNode(IXmlDocument doc, XmlNode Source, parent: XmlNodeNode) {
    //     m_doc = doc;
    //     m_parent = ParentNode;
    //     m_strName = Source.getName();
    //     m_childrenNodes = new Hashtable<string,XmlNode>();
    //     ArrayList<XmlNode> children = Source.getChildren();
    //     if (children != null) {
    //         // Copiar los hijos
    //         m_children = new ArrayList<>();
    //         for (int i = 0; i < children.size(); i++) {
    //             XmlNode n = children.get(i);
    //             XmlNode nc = new XmlNode(doc, n, this);
    //             String name = n.getName();
    //             if (n.attrExists(Utils.PROP_ATTR_NAME) && (Utils.COLL_COLL.equals(name) || Utils.PROP_ATTR_GROUP.equals(name) || Utils.PROP_NAME.equals(name) || Utils.PROP_ATTR_FRAME.equals(name) || Utils.PROP_ATTR_CONTENTNAME.equals(name))) {
    //                 addChild(nc, name, Utils.PROP_ATTR_NAME, n.getAttrValue(Utils.PROP_ATTR_NAME));
    //             } else {
    //                 addChild(nc, name, null, null);
    //             }
    //         }
    //     }
    //     m_attrs = new XoneAttributesImpl((XoneAttributesImpl) Source.getAttrs());
    //     m_strText = Source.getText();
    // }
    // public XmlNode(IXmlDocument doc, parent: XmlNodeNode, String name) {
    //     m_doc = doc;
    //     //m_node =SourceNode;
    //     m_children = new ArrayList<>();
    //     //m_attributes =new Hashtable<String,String> ();
    //     m_childrenNodes = new Hashtable<string,XmlNode>();
    //     if (ParentNode != null) {
    //         ParentNode.addChild(this, name, null, null);
    //     }
    //     m_strName = name;
    //     m_parent = ParentNode;
    // }
    XmlNode.prototype.AddPropToRoot = function (parent, node, nodeName, defaultAttr, defaultAttrValue) {
        if (parent == null) {
            return;
        }
        if (StringUtils_1.default.areEquals(parent.getName(), Utils_1.Utils.COLL_COLL)) {
            parent.addFastChild(node, nodeName, defaultAttr, defaultAttrValue);
        }
        else {
            var tmp = parent.getParentNode();
            if (tmp != null) {
                this.AddPropToRoot(tmp, node, nodeName, defaultAttr, defaultAttrValue);
            }
        }
    };
    Object.defineProperty(XmlNode.prototype, "attrs", {
        get: function () {
            return this.m_attrs;
        },
        enumerable: false,
        configurable: true
    });
    XmlNode.prototype.addChild = function (node, nodeName, defaultAttr, defaultAttrValue) {
        if (!TextUtils_1.default.isEmpty(defaultAttr) && !TextUtils_1.default.isEmpty(defaultAttrValue)) {
            this.m_childrenNodes.put(Utils_1.Utils.formatKey(nodeName, defaultAttr, defaultAttrValue), node);
            if (nodeName.equals(Utils_1.Utils.PROP_NAME) || nodeName.equals(Utils_1.Utils.PROP_ATTR_FRAME) || nodeName.equals(Utils_1.Utils.PROP_ATTR_CONTENTNAME)) {
                this.AddPropToRoot(this, node, nodeName, defaultAttr, defaultAttrValue);
            }
        }
        else {
            var name_1 = this.getName();
            if (Utils_1.Utils.COLL_COLL.equals(name_1) || (Utils_1.Utils.PROP_ATTR_GROUP.equals(name_1) && !(nodeName.equals(Utils_1.Utils.PROP_NAME) || nodeName.equals(Utils_1.Utils.PROP_ATTR_FRAME) || nodeName.equals(Utils_1.Utils.PROP_ATTR_CONTENTNAME)))) {
                this.AddPropToRoot(this, node, nodeName, defaultAttr, defaultAttrValue);
            }
        }
        this.m_children.push(node);
    };
    XmlNode.prototype.addFastChild = function (node, nodeName, defaultAttr, defaultAttrValue) {
        switch (nodeName) {
            case Utils_1.Utils.PROP_NAME:
                if (this.m_cachePropNodes == null) {
                    this.m_cachePropNodes = new Hashtable_1.default();
                }
                this.m_cachePropNodes.put(Utils_1.Utils.formatKey(nodeName, defaultAttr, defaultAttrValue), node);
                break;
            case Utils_1.Utils.PROP_ATTR_FRAME:
            case Utils_1.Utils.PROP_ATTR_CONTENTNAME:
                if (this.m_cacheContainersNodes == null) {
                    this.m_cacheContainersNodes = new Hashtable_1.default();
                }
                this.m_cacheContainersNodes.put(Utils_1.Utils.formatKey(nodeName, defaultAttr, defaultAttrValue), node);
                break;
            default:
                if (this.m_cacheOtherNodes == null) {
                    this.m_cacheOtherNodes = new Hashtable_1.default();
                }
                this.m_cacheOtherNodes.put(nodeName, node);
                break;
        }
    };
    XmlNode.prototype.appendChild = function (node) {
        var nodeName = node.getName();
        var defaultAttr = "name";
        var defaultAttrValue = "";
        if (!TextUtils_1.default.isEmpty(defaultAttr) && !TextUtils_1.default.isEmpty(defaultAttrValue)) {
            this.m_childrenNodes.put(Utils_1.Utils.formatKey(nodeName, defaultAttr, defaultAttrValue), node);
            if (nodeName.equals(Utils_1.Utils.PROP_NAME) || nodeName.equals(Utils_1.Utils.PROP_ATTR_FRAME) || nodeName.equals(Utils_1.Utils.PROP_ATTR_CONTENTNAME)) {
                this.AddPropToRoot(this, node, nodeName, defaultAttr, defaultAttrValue);
            }
        }
        else {
            var name_2 = this.getName();
            if (Utils_1.Utils.COLL_COLL.equals(name_2) || (Utils_1.Utils.PROP_ATTR_GROUP.equals(name_2) && !(nodeName.equals(Utils_1.Utils.PROP_NAME) || nodeName.equals(Utils_1.Utils.PROP_ATTR_FRAME) || nodeName.equals(Utils_1.Utils.PROP_ATTR_CONTENTNAME)))) {
                this.AddPropToRoot(this, node, nodeName, defaultAttr, defaultAttrValue);
            }
        }
        this.m_children.push(node);
    };
    XmlNode.prototype.getName = function () {
        return this.nodeName;
    };
    Object.defineProperty(XmlNode.prototype, "nodeName", {
        get: function () {
            return this.m_strName;
        },
        enumerable: false,
        configurable: true
    });
    XmlNode.prototype.setName = function (value) {
        this.m_strName = value;
    };
    XmlNode.prototype.getText = function () {
        return this.m_strText;
    };
    XmlNode.prototype.getBooleanText = function (bDefault) {
        return StringUtils_1.default.ParseBoolValue(this.m_strText, bDefault);
    };
    XmlNode.prototype.setText = function (value) {
        this.m_strText = value;
    };
    Object.defineProperty(XmlNode.prototype, "attributes", {
        get: function () {
            return this.m_attrs;
        },
        enumerable: false,
        configurable: true
    });
    XmlNode.prototype.getAttributes = function () {
        return this.m_attrs;
    };
    // Tag: L0610201502 Si tiene eventos en los atributos se devuelve la lista
    XmlNode.prototype.getEvents = function () {
        return this.lstEvents;
    };
    XmlNode.prototype.getChildren = function () {
        return this.m_children;
    };
    XmlNode.prototype.merge = function (parentNode) {
        return this.mergeObj(parentNode.clone(), this, [{ nodename: 'coll', attrname: '*' }, { nodename: 'group', attrname: 'id' }, { nodename: 'frame', attrname: 'name' }, { nodename: 'prop', attrname: 'name' }]);
        //return this;
    };
    XmlNode.prototype.addMergeChild = function (obj, child) {
        obj.appendChild(child);
    };
    XmlNode.prototype.findNodeAttr = function (obj, attrName) {
        return { value: obj.getAttrValue(attrName, null) };
        // var attrs = obj.attributes;
        // for (var i = 0; i < attrs.length; ++i) {
        //     if (attrs[i].nodeName == attrName) {
        //         return attrs[i];
        //     }
        // }
        // return null;
    };
    XmlNode.prototype.isEquNode = function (obj1, obj2, config) {
        if (obj1.nodeName == obj2.nodeName) {
            var max = config.length;
            for (var i = 0; i < max; ++i) {
                if (config[i].nodename == obj1.nodeName) {
                    if (config[i].attrname == '*') {
                        return true;
                    }
                    var attr1 = this.findNodeAttr(obj1, config[i].attrname);
                    if (attr1 == null) {
                        return false;
                    }
                    var attr2 = this.findNodeAttr(obj2, config[i].attrname);
                    if (attr2 == null) {
                        return false;
                    }
                    if (attr1.value == attr2.value) {
                        return true;
                    }
                    return false;
                }
            }
        }
        return false;
    };
    XmlNode.prototype.findSameChild = function (obj, child, config) {
        var nums = obj.getChildren().length;
        var childs = obj.getChildren();
        for (var i = 0; i < nums; ++i) {
            var curobj = childs[i];
            if (this.isEquNode(curobj, child, config)) {
                return curobj;
            }
        }
        return null;
    };
    XmlNode.prototype.mergeAttrs = function (obj1, obj2) {
        obj2.attributes.keys().forEach(function (element) {
            obj1.attributes.setValue(element, obj2.attributes.getValue(element));
        });
    };
    XmlNode.prototype.mergeObj = function (obj1, obj2, config) {
        var isequ = this.isEquNode(obj1, obj2, config);
        if (isequ) {
            this.mergeAttrs(obj1, obj2);
        }
        else {
            obj1.appendChild(obj2);
            return obj1;
        }
        if (!obj2.hasChildNodes()) {
            return obj1;
        }
        var nums2 = obj2.getChildren().length;
        var childs2 = obj2.getChildren();
        for (var i = 0; i < nums2; ++i) {
            var curobj = childs2[i];
            if (curobj.getName() == '#text') {
                continue;
            }
            //this.mergeObj(obj1child, curobj, config);
            //logger.normal.log('info', 'obj2 ', curobj.nodeName);
            var obj1child = this.findSameChild(obj1, curobj, config);
            if (obj1child != null) {
                //logger.normal.log('info', 'merge ', curobj.nodeName);
                this.mergeObj(obj1child, curobj, config);
            }
            else {
                obj1.appendChild(curobj);
                //this.mergeObj(obj1, curobj, config);
            }
        }
        return obj1;
    };
    XmlNode.prototype.getDocument = function () {
        throw new Exception_1.Exception("Not implement");
    };
    XmlNode.prototype.getAttrValue = function (sAttrName, sDefault) {
        if (sDefault === void 0) { sDefault = ""; }
        var sValue = this.m_attrs.getValue(sAttrName);
        if (sValue == null) {
            return sDefault;
        }
        return sValue;
    };
    XmlNode.prototype.setAttrValue = function (AttrName, value) {
        this.m_attrs.setValue(AttrName, value);
    };
    XmlNode.prototype.deleteAttribute = function (AttrName) {
        this.m_attrs.deleteAttribute(AttrName);
    };
    // Luis: Funcion comun para detectar condiciones rapidas para encontrar la cache
    XmlNode.prototype.CheckCacheConditions = function (map, NodeName) {
        var cacheNames = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            cacheNames[_i - 2] = arguments[_i];
        }
        if (map == null) {
            return false;
        }
        if (map.isEmpty()) {
            return false;
        }
        if (cacheNames.length == 1) {
            return NodeName.equals(cacheNames[0]);
        }
        else if (cacheNames.length > 1) {
            return cacheNames.indexOf(NodeName) >= 0;
        }
        return false;
    };
    // Luis: Funcion comun para detectar condiciones rapidas para encontrar la cache
    XmlNode.prototype.CheckIfCacheExists = function (map, sKey) {
        if (map == null) {
            return false;
        }
        if (map.isEmpty()) {
            return false;
        }
        return map.containsKey(sKey);
    };
    XmlNode.prototype.getParentNode = function () {
        return this.m_parent;
    };
    XmlNode.prototype.setParentNode = function (parentNode) {
        this.m_parent = parentNode;
    };
    XmlNode.prototype.getChildNodes = function () {
        if (this.m_allChildren != null) {
            return this.m_allChildren;
        }
        // Si no, la creamos ahora
        this.m_allChildren = new XmlNodeList_1.default();
        for (var i = 0; i < this.m_children.length; i++) { // Comprobar cada nombre
            var node = this.m_children[i];
            this.m_allChildren.addNode(node);
        } // Comprobar cada nombre
        return this.m_allChildren;
    };
    XmlNode.prototype.hasChildNodes = function () {
        try {
            if (this.m_allChildren != null && this.m_allChildren.count() > 0) {
                return true;
            }
            if (this.m_children != null && this.m_children.length > 0) {
                return true;
            }
            return false;
        }
        catch (ex) {
            ex.printStackTrace();
            return false;
        }
    };
    /**
     * Devuelve TRUE si el atributo cuyo nombre se pasa como par�metro existe en la lista de atributos del nodo.
     *
     * @param AttrName Nobmre del atributo cuya existencia se quiere comprobar
     * @return Devuelve TRUE si existe el atributo.
     */
    XmlNode.prototype.attrExists = function (AttrName) {
        return this.m_attrs.getIndex(AttrName) >= 0;
    };
    /**
     * @param m_attrs the m_attrs to set
     */
    XmlNode.prototype.setAttrs = function (m_attrs) {
        this.m_attrs = m_attrs;
    };
    /**
     * @return the m_attrs
     */
    XmlNode.prototype.getAttrs = function () {
        return this.m_attrs;
    };
    /**
     * A13081301: Funcionalidad para manejar XML a nivel de script y modificar estructuras en runtime.
     *
     * @return
     */
    XmlNode.prototype.getXml = function () {
        return null;
    };
    /**
     * A13081301: Funcionalidad para manejar XML a nivel de script y modificar estructuras en runtime.
     * Inserta un nodo antes del que se diga como par�metro...
     *
     * @param NewChild Nodo a insertar
     * @param Before   Nodo delante del que se inserta. NULL para agregar al final.
     */
    XmlNode.prototype.InsertBefore = function (NewChild, Before) {
        this.addToCache(NewChild);
        var idx = this.m_children.indexOf(Before);
        if (idx == -1) {
            this.m_children.push(NewChild);
        }
        else {
            this.m_children.add(idx, NewChild);
        }
    };
    /**
     * A0206201401: Luis. Funcionalidad para manejar XML a nivel de script y modificar estructuras
     * en runtime. Inserta un nodo antes del que se diga como parámetro...
     *
     * @param NewChild Nodo a insertar
     * @param After    Nodo detras del que se inserta. NULL para agregar al final.
     */
    XmlNode.prototype.InsertAfter = function (NewChild, After) {
        this.addToCache(NewChild);
        var idx = this.m_children.indexOf(After);
        if (idx == -1) {
            this.m_children.push(NewChild);
        }
        else {
            this.m_children.add(idx + 1, NewChild);
        }
    };
    XmlNode.prototype.addToCache = function (child) {
        var nodeName = child.getName();
        if (child.attrExists(Utils_1.Utils.PROP_ATTR_NAME)) {
            var defaultAttr = Utils_1.Utils.PROP_ATTR_NAME;
            var defaultAttrValue = child.getAttrValue(Utils_1.Utils.PROP_ATTR_NAME);
            if ((Utils_1.Utils.COLL_COLL.equals(nodeName) || Utils_1.Utils.PROP_ATTR_GROUP.equals(nodeName) || Utils_1.Utils.PROP_NAME.equals(nodeName) || Utils_1.Utils.PROP_ATTR_FRAME.equals(nodeName) || Utils_1.Utils.PROP_ATTR_CONTENTNAME.equals(nodeName))) {
                if (!TextUtils_1.default.isEmpty(defaultAttr) && !TextUtils_1.default.isEmpty(defaultAttrValue)) {
                    this.m_childrenNodes.put(Utils_1.Utils.formatKey(nodeName, defaultAttr, defaultAttrValue), child);
                    if (nodeName.equals(Utils_1.Utils.PROP_NAME) || nodeName.equals(Utils_1.Utils.PROP_ATTR_FRAME) || nodeName.equals(Utils_1.Utils.PROP_ATTR_CONTENTNAME)) {
                        this.AddPropToRoot(this, child, nodeName, defaultAttr, defaultAttrValue);
                    }
                }
                else {
                    var name_3 = this.getName();
                    if (Utils_1.Utils.COLL_COLL.equals(name_3) || (Utils_1.Utils.PROP_ATTR_GROUP.equals(name_3) && !(nodeName.equals(Utils_1.Utils.PROP_NAME) || nodeName.equals(Utils_1.Utils.PROP_ATTR_FRAME) || nodeName.equals(Utils_1.Utils.PROP_ATTR_CONTENTNAME)))) {
                        this.AddPropToRoot(this, child, nodeName, defaultAttr, defaultAttrValue);
                    }
                }
            }
        }
    };
    /**
     * A0206201402: Luis. Funcionalidad para manejar XML a nivel de script y modificar estructuras
     * en runtime. Borra un nodo de las listas
     *
     * @param child Nodo a borrar
     */
    XmlNode.prototype.Remove = function (child) {
        var _this = this;
        try {
            var idx = this.m_children.indexOf(child);
            if (idx > -1) {
                this.m_children.remove(idx);
                this.m_childrenNodes.entrySet().forEach(function (entry) {
                    if (entry[1] == child) {
                        _this.m_childrenNodes.delete(entry[0]);
                    }
                });
                return true;
            }
            return false;
        }
        catch (e) {
            e.printStackTrace();
            return false;
        }
    };
    /**
     * A11121601: Implementación del picaíto en los XML de las maquinarias modernas. Reemplaza un
     * hijo en la lista de este nodo por el que se pase.
     *
     * @param Original Nodo que se quiere reemplazar.
     * @param NewNode  Nuevo nodo para poner en el lugar del original.
     */
    XmlNode.prototype.replaceChild = function (Original, NewNode) {
        if (this.m_children != null) { // Reemplazar
            var nIndex = this.m_children.indexOf(Original);
            if (nIndex >= 0) { // Est�
                this.m_children.add(nIndex, NewNode);
                this.Remove(Original);
            } // Est�
        } // Reemplazar
        if (this.m_childrenNodes != null) { // Buscar y sustituir
            this.m_childrenNodes.clear();
            //
            // TODO PROGRAMAR ESTO
            // Si est� en la lista organizada esta tenemos que quitarlo...
            //
        } // Buscar y sustituir
    };
    XmlNode.prototype.clone = function () {
        var objResult = new XmlNode(null, this.nodeName, this.attributes.clone(), null, null, this.lstEvents);
        this.m_children.forEach(function (node) {
            objResult.appendChild(node.clone());
        });
        return objResult;
    };
    XmlNode.prototype.describeContents = function () {
        return 0;
    };
    XmlNode.prototype.selectNodes = function (NodeName, AttrName, AttrValue, Exist) {
        return this.SelectNodes(NodeName, AttrName, AttrValue, Exist);
    };
    XmlNode.prototype.SelectNodes = function (NodeName, AttrName, AttrValue, Exist) {
        // Si tiene valor, es el de toda la vida
        if (!TextUtils_1.default.isEmpty(AttrValue)) {
            return this.SelectNodesInt3(NodeName, AttrName, AttrValue);
        }
        if (this.CheckCacheConditions(this.m_cachePropNodes, NodeName, Utils_1.Utils.PROP_NAME)) {
            return this.SelectNodesHashExist(this.m_cachePropNodes, NodeName, AttrName, Exist);
        }
        if (this.CheckCacheConditions(this.m_cacheContainersNodes, NodeName, Utils_1.Utils.PROP_ATTR_CONTENTNAME, Utils_1.Utils.PROP_ATTR_FRAME)) {
            return this.SelectNodesHashExist(this.m_cacheContainersNodes, NodeName, AttrName, Exist);
        }
        //
        // Crear la lista
        var list = new XmlNodeList_1.default();
        for (var i = 0; i < this.m_children.length; i++) { // Comprobar cada nombre
            var node = this.m_children[i];
            if (node.getName().equals(NodeName)) { // Al menos el nombre lo tiene
                var strAttr = node.getAttrValue(AttrName);
                if (TextUtils_1.default.isEmpty(strAttr)) { // No existe
                    if (Exist) {
                        continue;
                    }
                } // No existe
                else { // Existe
                    if (!Exist) {
                        continue;
                    }
                } // Existe
                // A la lista
                list.addNode(node);
            } // Al menos el nombre lo tiene
        } // Comprobar cada nombre
        // Devolver la lista en cuesti�n
        return list;
    };
    XmlNode.prototype.SelectNodesInt1 = function (NodeName) {
        // Como hemos hecho una cache de props y frames pues lo mejor es buscar ahi
        if (this.CheckCacheConditions(this.m_cachePropNodes, NodeName, Utils_1.Utils.PROP_NAME)) {
            return new XmlNodeList_1.default(this.m_cachePropNodes.values());
        }
        if (this.CheckCacheConditions(this.m_cacheContainersNodes, NodeName, Utils_1.Utils.PROP_ATTR_CONTENTNAME, Utils_1.Utils.PROP_ATTR_FRAME)) {
            return this.SelectNodesHash2(this.m_cacheContainersNodes, NodeName);
        }
        var list = new XmlNodeList_1.default();
        // Ahora buscar en los hijos
        for (var i = 0; i < this.m_children.length; i++) { // Comprobar cada nombre
            var node = this.m_children[i];
            var localName = node.getName();
            if (TextUtils_1.default.equals(localName, NodeName)) {
                list.addNode(node);
            }
        } // Comprobar cada nombre
        return list;
    };
    XmlNode.prototype.SelectNodesHash2 = function (nodeList, NodeName) {
        var list = new XmlNodeList_1.default();
        nodeList.values().forEach(function (node) {
            var localName = node.getName();
            if (TextUtils_1.default.equals(localName, NodeName)) {
                list.addNode(node);
            }
        });
        return list;
    };
    XmlNode.prototype.SelectNodesHash4 = function (nodeList, NodeName, AttrName, AttrValue) {
        var list = new XmlNodeList_1.default();
        nodeList.values().forEach(function (node) {
            if (node.getName().equals(NodeName)) { // Al menos el nombre lo tiene
                var strAttr = node.getAttrValue(AttrName);
                if (TextUtils_1.default.equals(strAttr, AttrValue)) {
                    list.addNode(node);
                }
            } // Al menos el nombre lo tiene
        }); // Comprobar cada nombre
        // No aparece
        return list;
    };
    XmlNode.prototype.SelectNodesInt3 = function (NodeName, AttrName, AttrValue) {
        if (this.CheckCacheConditions(this.m_cachePropNodes, NodeName, Utils_1.Utils.PROP_NAME)) {
            return this.SelectNodesHash4(this.m_cachePropNodes, NodeName, AttrName, AttrValue);
        }
        if (this.CheckCacheConditions(this.m_cacheContainersNodes, NodeName, Utils_1.Utils.PROP_ATTR_CONTENTNAME, Utils_1.Utils.PROP_ATTR_FRAME)) {
            return this.SelectNodesHash4(this.m_cacheContainersNodes, NodeName, AttrName, AttrValue);
        }
        var list = new XmlNodeList_1.default();
        for (var i = 0; i < this.m_children.length; i++) { // Comprobar cada nombre
            var node = this.m_children[i];
            if (node.getName().equals(NodeName)) { // Al menos el nombre lo tiene
                var strAttr = node.getAttrValue(AttrName);
                if (TextUtils_1.default.equals(strAttr, AttrValue)) {
                    list.addNode(node);
                }
            } // Al menos el nombre lo tiene
        } // Comprobar cada nombre
        // No aparece
        return list;
    };
    /**
     * Sobrecarga que permite buscar nodos con X atributo independientemente del valor de este.
     *
     * @param NodeName
     * @param AttrName
     * @return
     */
    XmlNode.prototype.SelectNodesStr2 = function (NodeName, AttrName) {
        return this.SelectNodes(NodeName, AttrName, null, true);
    };
    /**
     * Equivalente de SelecNodes con la opci�n de poder filtrar por la existencia o no existencia de un atributo determinado
     * pasando NULL como valor del atributo
     *
     * @param NodeName  Nombre de los nodos que van a la lista.
     * @param AttrName  Atributo por el que se quiere comparar o cuya existencia se quiere verificar.
     * @param AttrValue Valor del atributo para comparaci�n. NULL si lo que se quiere es verificar existencia.
     * @param Exist     Si AttrValue es NULL, TRUE para retornar nodos con el atributo, FALSE para retornar nodos sin el atributo.
     * @return Devuelve la lista con los nodos que cumplen la condici�n.
     */
    XmlNode.prototype.SelectNodesHashExist = function (nodeList, NodeName, AttrName, Exist) {
        //
        // Crear la lista
        var list = new XmlNodeList_1.default();
        nodeList.values().forEach(function (node) {
            if (node.getName().equals(NodeName)) { // Al menos el nombre lo tiene
                var strAttr = node.getAttrValue(AttrName);
                if (TextUtils_1.default.isEmpty(strAttr)) { // No existe
                    if (Exist) {
                        return;
                    }
                } // No existe
                else { // Existe
                    if (!Exist) {
                        return;
                    }
                } // Existe
                // A la lista
                list.addNode(node);
            } // Al menos el nombre lo tiene
        }); // Comprobar cada nombre
        // Devolver la lista en cuesti�n
        return list;
    };
    XmlNode.prototype.selectSingleNode = function (NodeName, AttrName, AttrValue) {
        return this.SelectSingleNode(NodeName, AttrName, AttrValue);
    };
    XmlNode.prototype.SelectSingleNode = function (NodeName, AttrName, AttrValue) {
        if (AttrName == null)
            return this.SelectSingleNodeInt1(NodeName);
        if (AttrValue == null)
            return this.SelectSingleNodeIntExist(NodeName, AttrName, true);
        if (typeof AttrValue === 'boolean')
            return this.SelectSingleNodeIntExist(NodeName, AttrName, AttrValue);
        return this.SelectSingleNodeInt3(NodeName, AttrName, AttrValue);
    };
    XmlNode.prototype.SelectSingleNodeInt1 = function (NodeName) {
        // Como hemos hecho una cache de props y frames pues lo mejor es buscar ahi
        if (this.CheckCacheConditions(this.m_cachePropNodes, NodeName, Utils_1.Utils.PROP_NAME)) {
            return this.m_cachePropNodes.values()[0];
        }
        if (this.CheckCacheConditions(this.m_cacheContainersNodes, NodeName, Utils_1.Utils.PROP_ATTR_CONTENTNAME, Utils_1.Utils.PROP_ATTR_FRAME)) {
            return this.m_cacheContainersNodes.values()[0];
        }
        if (this.m_cacheOtherNodes != null) {
            if (!this.m_cacheOtherNodes.isEmpty() && this.m_cacheOtherNodes.containsKey(NodeName)) {
                return this.m_cacheOtherNodes.get(NodeName);
            }
        }
        // Ahora buscar en los hijos
        for (var i = 0; i < this.m_children.length; i++) { // Comprobar cada nombre
            var node = this.m_children[i];
            if (TextUtils_1.default.equals(node.getName(), NodeName)) {
                return node;
            }
            if (Utils_1.Utils.PROP_ATTR_GROUP.equals(node.getName())) { // Vamos a buscar al menos en el primer nivel del group porque antes se permitia
                node = node.SelectSingleNode(NodeName);
                if (node != null) {
                    return node;
                }
            }
        } // Comprobar cada nombre
        return null;
    };
    XmlNode.prototype.SelectSingleNodeHash4 = function (nodeList, NodeName, AttrName, AttrValue) {
        nodeList.values().forEach(function (node) {
            var localName = node.getName();
            if (TextUtils_1.default.equals(localName, NodeName)) {
                if (TextUtils_1.default.equals(node.getAttrValue(AttrName), AttrValue)) {
                    return node;
                }
            }
        });
        return null;
    };
    XmlNode.prototype.SelectSingleNodeInt3 = function (NodeName, AttrName, AttrValue) {
        var node = null;
        if (TextUtils_1.default.equals(Utils_1.Utils.PROP_ATTR_NAME, AttrName)) {
            // Como hemos hecho una cache de props y frames pues lo mejor es buscar ahi
            var sKey = Utils_1.Utils.formatKey(NodeName, AttrName, AttrValue);
            if (this.CheckCacheConditions(this.m_cachePropNodes, NodeName, Utils_1.Utils.PROP_NAME) && this.CheckIfCacheExists(this.m_cachePropNodes, sKey)) {
                return this.m_cachePropNodes.get(sKey);
            }
            if (this.CheckCacheConditions(this.m_cacheContainersNodes, NodeName, Utils_1.Utils.PROP_ATTR_CONTENTNAME, Utils_1.Utils.PROP_ATTR_FRAME) && this.CheckIfCacheExists(this.m_cacheContainersNodes, sKey)) {
                return this.m_cacheContainersNodes.get(sKey);
            }
            node = this.m_childrenNodes.get(sKey);
        }
        else if (this.CheckCacheConditions(this.m_cachePropNodes, NodeName, Utils_1.Utils.PROP_NAME)) { // Agregado soporte para buscar un nodo por un atributo
            node = this.SelectSingleNodeHash4(this.m_cachePropNodes, NodeName, AttrName, AttrValue);
        }
        else if (this.CheckCacheConditions(this.m_cacheContainersNodes, NodeName, Utils_1.Utils.PROP_ATTR_CONTENTNAME, Utils_1.Utils.PROP_ATTR_FRAME)) {
            node = this.SelectSingleNodeHash4(this.m_cacheContainersNodes, NodeName, AttrName, AttrValue);
        }
        if (node != null) {
            return node;
        }
        this.m_children.forEach(function (node) {
            var localName = node.getName();
            if (localName.equals(NodeName)) { // Al menos el nombre lo tiene
                var strAttr = node.getAttrValue(AttrName);
                if (TextUtils_1.default.equals(strAttr, AttrValue)) {
                    return node;
                }
            } // Al menos el nombre lo tiene
        }); // Comprobar cada nombre
        // No aparece
        return null;
    };
    XmlNode.prototype.SelectSingleNodeHashExist = function (nodeList, NodeName, AttrName, Exists) {
        nodeList.values().forEach(function (node) {
            var localName = node.getName();
            if (localName.equals(NodeName)) { // Al menos el nombre lo tiene
                var strAttr = node.getAttrValue(AttrName);
                if (Exists && !TextUtils_1.default.isEmpty(strAttr)) {
                    return node;
                }
                else if (!Exists && TextUtils_1.default.isEmpty(strAttr)) {
                    return node;
                }
            } // Al menos el nombre lo tiene
        }); // Comprobar cada nombre
        // No aparece
        return null;
    };
    // A10100703:	Funci�n para pedir un nodo del fichero XML de la aplicaci�n.
    // Esto hace falta para poner el GetNode a nivel de XoneApplication
    XmlNode.prototype.SelectSingleNodeIntExist = function (NodeName, AttrName, Exists) {
        if (this.CheckCacheConditions(this.m_cachePropNodes, NodeName, Utils_1.Utils.PROP_NAME)) {
            return this.SelectSingleNodeHashExist(this.m_cachePropNodes, NodeName, AttrName, Exists);
        }
        if (this.CheckCacheConditions(this.m_cacheContainersNodes, NodeName, Utils_1.Utils.PROP_ATTR_CONTENTNAME, Utils_1.Utils.PROP_ATTR_FRAME)) {
            return this.SelectSingleNodeHashExist(this.m_cacheContainersNodes, NodeName, AttrName, Exists);
        }
        this.m_children.forEach(function (node) {
            var localName = node.getName();
            if (localName.equals(NodeName)) { // Al menos el nombre lo tiene
                var strAttr = node.getAttrValue(AttrName);
                if (Exists && !TextUtils_1.default.isEmpty(strAttr)) {
                    return node;
                }
                else if (!Exists && TextUtils_1.default.isEmpty(strAttr)) {
                    return node;
                }
            } // Al menos el nombre lo tiene
        }); // Comprobar cada nombre
        // No aparece
        return null;
    };
    XmlNode.prototype.toJSON = function () {
        var _this = this;
        var nodesName = "childs";
        var result = {};
        result[this.getName()] = {};
        result[this.getName()]["attributes"] = this.m_attrs.toJSON();
        if (this.m_children.length > 0) {
            result[this.getName()][nodesName] = [];
            this.m_children.forEach(function (item) { return result[_this.getName()][nodesName].push(item.toJSON()); });
        }
        return result;
    };
    return XmlNode;
}());
exports.default = XmlNode;

//# sourceMappingURL=XmlNode.js.map
